module.exports = __webpack_public_path__ + "img/1.d2d748d7.svg";